import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss']
})
export class SearchBarComponent implements OnInit {

  form !: FormGroup;

  constructor( private builder: FormBuilder, private router : Router ) { }
  public searchData !:string

  ngOnInit(): void {
    this.form = this.builder.group({
      search: [''],
    });

    
  }

  public onSubmit() {
    this.searchData = this.form.controls.search.value.trim();
    
    this.router.navigate(['search-results', this.searchData]);
  }

}
